import React, { useContext } from 'react';
import { ReloadOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import Auth0RoleEditDialog from '@totem/components/administration/auth0/roles/Auth0RoleEditDialog';
import Auth0RolesContext from '@totem/components/administration/auth0/roles/Auth0RolesContext';
import Auth0RolesSyncResultsModal from '@totem/components/administration/auth0/roles/Auth0RolesSyncResultsModal';
import Auth0RolesTable from '@totem/components/administration/auth0/roles/Auth0RolesTable';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

export const Auth0RolesExtra = () => {
  const { data, syncing, onRefresh, onSync } = useContext(Auth0RolesContext);

  return (
    <Space>
      <RecordCountBadge count={data.length} />
      <Tooltip title="Sync all roles from Auth0 across every connection. This can take a few minutes.">
        <Button icon={<SyncOutlined />} loading={syncing} onClick={onSync}>
          Sync
        </Button>
      </Tooltip>
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export const Auth0RolesLayout = () => (
  <>
    <Auth0RolesTable />
    <Auth0RoleEditDialog />
    <Auth0RolesSyncResultsModal />
  </>
);

export default Auth0RolesLayout;
